module.exports = __webpack_public_path__ + "img/sach_ctst.37c44aca.png";